export const franceCompetencesUrl = (cert) => {
  if (!cert) return null;
  if (cert.url_fiche) return cert.url_fiche;
  const code = (cert.code_rncp || '').toUpperCase().replace(/\s/g, '');
  const match = code.match(/^(RNCP|RS)(\d+)$/);
  if (!match) return null;
  return `https://www.francecompetences.fr/recherche/${match[1].toLowerCase()}/${match[2]}/`;
};
